import { SETTINGS_PATHS } from "@/features/settings/paths"

/**
 * TS mirror of the backend notification vocabulary (notification_types.py).
 * This is the one shared vocabulary between engine and dashboard — adding a
 * type here without a renderer fails the build (see registry.ts `satisfies`).
 */
export const NOTIFICATION_TYPES = {
  QUESTIONNAIRE_READY: "questionnaire_ready",
  QUESTIONNAIRE_FAILED: "questionnaire_failed",
  DOCUMENT_INGESTION_FAILED: "document_ingestion_failed",
  DECLARATION_READY_FOR_REVIEW: "declaration_ready_for_review",
  DECLARATION_PROCESSING_FAILED: "declaration_processing_failed",
  CREDITS_LOW: "credits_low",
  TAGGED_MISSING_ANSWER: "tagged_missing_answer",
} as const

export type NotificationType =
  (typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES]

export const ACTION_NAMES = {
  OPEN_QUESTIONNAIRE: "open_questionnaire",
  OPEN_QUESTION: "open_question",
  OPEN_KNOWLEDGEBASE: "open_knowledgebase",
  OPEN_USAGE: "open_usage",
  OPEN_DECLARATION_REVIEW: "open_declaration_review",
  OPEN_DECLARATIONS: "open_declarations",
} as const

export type ActionName = (typeof ACTION_NAMES)[keyof typeof ACTION_NAMES]

/** The only recurring request in the system — keep it one cheap count. */
export const UNREAD_COUNT_POLL_INTERVAL_MS = 10_000

export const POPOVER_PAGE_SIZE = 20
export const CENTER_PAGE_SIZE = 50

export const NOTIFICATION_CENTER_ROUTE = "/notifications"
/** Notification preferences are a page of the settings area. */
export const NOTIFICATION_SETTINGS_ROUTE = SETTINGS_PATHS.notifications
